export default __webpack_public_path__ + "static/media/Conscript's Armguards of the Warring States.d489ce4f.jpg";